import { createFileRoute } from "@tanstack/react-router";

import { InviteCampaignsPage } from "./-components/invite-campaigns-page";

export const Route = createFileRoute("/operator/invites")({
  component: InviteCampaignsRoute,
});

function InviteCampaignsRoute() {
  const { access } = Route.useRouteContext();
  return <InviteCampaignsPage permissions={access.permissions} />;
}
